export const sampleSingleLabel = `<?xml version="1.0" encoding="utf-8"?>
<DesktopLabel Version="1">
    <DYMOLabel Version="3">
        <Description>DYMO Label</Description>
        <Orientation>Landscape</Orientation>
        <LabelName>Address</LabelName>
        <InitialLength>0</InitialLength>
        <BorderStyle>SolidLine</BorderStyle>
        <DYMORect>
            <DYMOPoint>
                <X>0.23</X>
                <Y>0.06</Y>
            </DYMOPoint>
            <Size>
                <Width>3.21</Width>
                <Height>0.9966666</Height>
            </Size>
        </DYMORect>
        <BorderColor>
            <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"> </Color>
            </SolidColorBrush>
        </BorderColor>
        <BorderThickness>1</BorderThickness>
        <Show_Border>False</Show_Border>
        <DynamicLayoutManager>
            <RotationBehavior>ClearObjects</RotationBehavior>
            <LabelObjects>
                <TextObject>
                    <Name>Line1</Name>
                    <Brushes>
                        <BackgroundBrush>
                            <SolidColorBrush>
                                <Color A="0" R="0" G="0" B="0"> </Color>
                            </SolidColorBrush>
                        </BackgroundBrush>
                        <BorderBrush>
                            <SolidColorBrush>
                                <Color A="1" R="0" G="0" B="0"> </Color>
                            </SolidColorBrush>
                        </BorderBrush>
                        <StrokeBrush>
                            <SolidColorBrush>
                                <Color A="1" R="0" G="0" B="0"> </Color>
                            </SolidColorBrush>
                        </StrokeBrush>
                        <FillBrush>
                            <SolidColorBrush>
                                <Color A="0" R="0" G="0" B="0"> </Color>
                            </SolidColorBrush>
                        </FillBrush>
                    </Brushes>
                    <Rotation>Rotation0</Rotation>
                    <OutlineThickness>1</OutlineThickness>
                    <IsOutlined>False</IsOutlined>
                    <BorderStyle>SolidLine</BorderStyle>
                    <Margin>
                        <DYMOThickness Left="0" Top="0" Right="0" Bottom="0" />
                    </Margin>
                    <HorizontalAlignment>Center</HorizontalAlignment>
                    <VerticalAlignment>Middle</VerticalAlignment>
                    <FitMode>None</FitMode>
                    <IsVertical>False</IsVertical>
                    <FormattedText>
                        <FitMode>None</FitMode>
                        <HorizontalAlignment>Center</HorizontalAlignment>
                        <VerticalAlignment>Middle</VerticalAlignment>
                        <IsVertical>False</IsVertical>
                        <LineTextSpan>
                            <TextSpan>
                                <Text>Line1</Text>
                                <FontInfo>
                                    <FontName>Segoe UI</FontName>
                                    <FontSize>8</FontSize>
                                    <IsBold>True</IsBold>
                                    <IsItalic>False</IsItalic>
                                    <IsUnderline>False</IsUnderline>
                                    <FontBrush>
                                        <SolidColorBrush>
                                            <Color A="1" R="0" G="0" B="0"> </Color>
                                        </SolidColorBrush>
                                    </FontBrush>
                                </FontInfo>
                            </TextSpan>
                        </LineTextSpan>
                    </FormattedText>
                    <ObjectLayout>
                        <DYMOPoint>
                            <X>0.23</X>
                            <Y>0.06</Y>
                        </DYMOPoint>
                        <Size>
                            <Width>3.193756</Width>
                            <Height>0.1368766</Height>
                        </Size>
                    </ObjectLayout>
                </TextObject>
                <TextObject>
                    <Name>Line2</Name>
                    <Brushes>
                        <BackgroundBrush>
                            <SolidColorBrush>
                                <Color A="0" R="0" G="0" B="0"> </Color>
                            </SolidColorBrush>
                        </BackgroundBrush>
                        <BorderBrush>
                            <SolidColorBrush>
                                <Color A="1" R="0" G="0" B="0"> </Color>
                            </SolidColorBrush>
                        </BorderBrush>
                        <StrokeBrush>
                            <SolidColorBrush>
                                <Color A="1" R="0" G="0" B="0"> </Color>
                            </SolidColorBrush>
                        </StrokeBrush>
                        <FillBrush>
                            <SolidColorBrush>
                                <Color A="0" R="0" G="0" B="0"> </Color>
                            </SolidColorBrush>
                        </FillBrush>
                    </Brushes>
                    <Rotation>Rotation0</Rotation>
                    <OutlineThickness>1</OutlineThickness>
                    <IsOutlined>False</IsOutlined>
                    <BorderStyle>SolidLine</BorderStyle>
                    <Margin>
                        <DYMOThickness Left="0" Top="0" Right="0" Bottom="0" />
                    </Margin>
                    <HorizontalAlignment>Center</HorizontalAlignment>
                    <VerticalAlignment>Middle</VerticalAlignment>
                    <FitMode>None</FitMode>
                    <IsVertical>False</IsVertical>
                    <FormattedText>
                        <FitMode>None</FitMode>
                        <HorizontalAlignment>Center</HorizontalAlignment>
                        <VerticalAlignment>Middle</VerticalAlignment>
                        <IsVertical>False</IsVertical>
                        <LineTextSpan>
                            <TextSpan>
                                <Text>Line2</Text>
                                <FontInfo>
                                    <FontName>Segoe UI</FontName>
                                    <FontSize>8</FontSize>
                                    <IsBold>False</IsBold>
                                    <IsItalic>False</IsItalic>
                                    <IsUnderline>False</IsUnderline>
                                    <FontBrush>
                                        <SolidColorBrush>
                                            <Color A="1" R="0" G="0" B="0"> </Color>
                                        </SolidColorBrush>
                                    </FontBrush>
                                </FontInfo>
                            </TextSpan>
                        </LineTextSpan>
                    </FormattedText>
                    <ObjectLayout>
                        <DYMOPoint>
                            <X>0.23</X>
                            <Y>0.1968766</Y>
                        </DYMOPoint>
                        <Size>
                            <Width>3.180007</Width>
                            <Height>0.1338767</Height>
                        </Size>
                    </ObjectLayout>
                </TextObject>
                <TextObject>
                    <Name>Line3</Name>
                    <Brushes>
                        <BackgroundBrush>
                            <SolidColorBrush>
                                <Color A="0" R="0" G="0" B="0"> </Color>
                            </SolidColorBrush>
                        </BackgroundBrush>
                        <BorderBrush>
                            <SolidColorBrush>
                                <Color A="1" R="0" G="0" B="0"> </Color>
                            </SolidColorBrush>
                        </BorderBrush>
                        <StrokeBrush>
                            <SolidColorBrush>
                                <Color A="1" R="0" G="0" B="0"> </Color>
                            </SolidColorBrush>
                        </StrokeBrush>
                        <FillBrush>
                            <SolidColorBrush>
                                <Color A="0" R="0" G="0" B="0"> </Color>
                            </SolidColorBrush>
                        </FillBrush>
                    </Brushes>
                    <Rotation>Rotation0</Rotation>
                    <OutlineThickness>1</OutlineThickness>
                    <IsOutlined>False</IsOutlined>
                    <BorderStyle>SolidLine</BorderStyle>
                    <Margin>
                        <DYMOThickness Left="0" Top="0" Right="0" Bottom="0" />
                    </Margin>
                    <HorizontalAlignment>Center</HorizontalAlignment>
                    <VerticalAlignment>Middle</VerticalAlignment>
                    <FitMode>None</FitMode>
                    <IsVertical>False</IsVertical>
                    <FormattedText>
                        <FitMode>None</FitMode>
                        <HorizontalAlignment>Center</HorizontalAlignment>
                        <VerticalAlignment>Middle</VerticalAlignment>
                        <IsVertical>False</IsVertical>
                        <LineTextSpan>
                            <TextSpan>
                                <Text>Line3</Text>
                                <FontInfo>
                                    <FontName>Segoe UI</FontName>
                                    <FontSize>10</FontSize>
                                    <IsBold>False</IsBold>
                                    <IsItalic>False</IsItalic>
                                    <IsUnderline>False</IsUnderline>
                                    <FontBrush>
                                        <SolidColorBrush>
                                            <Color A="1" R="0" G="0" B="0"> </Color>
                                        </SolidColorBrush>
                                    </FontBrush>
                                </FontInfo>
                            </TextSpan>
                        </LineTextSpan>
                    </FormattedText>
                    <ObjectLayout>
                        <DYMOPoint>
                            <X>0.23</X>
                            <Y>0.7875001</Y>
                        </DYMOPoint>
                        <Size>
                            <Width>3.19878</Width>
                            <Height>0.2691666</Height>
                        </Size>
                    </ObjectLayout>
                </TextObject>
                <BarcodeObject>
                    <Name>ItemCode</Name>
                    <Brushes>
                        <BackgroundBrush>
                            <SolidColorBrush>
                                <Color A="1" R="1" G="1" B="1"> </Color>
                            </SolidColorBrush>
                        </BackgroundBrush>
                        <BorderBrush>
                            <SolidColorBrush>
                                <Color A="1" R="0" G="0" B="0"> </Color>
                            </SolidColorBrush>
                        </BorderBrush>
                        <StrokeBrush>
                            <SolidColorBrush>
                                <Color A="1" R="0" G="0" B="0"> </Color>
                            </SolidColorBrush>
                        </StrokeBrush>
                        <FillBrush>
                            <SolidColorBrush>
                                <Color A="1" R="0" G="0" B="0"> </Color>
                            </SolidColorBrush>
                        </FillBrush>
                    </Brushes>
                    <Rotation>Rotation0</Rotation>
                    <OutlineThickness>1</OutlineThickness>
                    <IsOutlined>False</IsOutlined>
                    <BorderStyle>SolidLine</BorderStyle>
                    <Margin>
                        <DYMOThickness Left="0" Top="0" Right="0" Bottom="0" />
                    </Margin>
                    <BarcodeFormat>Code128B</BarcodeFormat>
                    <Data>
                        <MultiDataString>
                            <DataString>1234</DataString>
                        </MultiDataString>
                    </Data>
                    <HorizontalAlignment>Center</HorizontalAlignment>
                    <VerticalAlignment>Middle</VerticalAlignment>
                    <Size>Medium</Size>
                    <TextPosition>None</TextPosition>
                    <FontInfo>
                        <FontName>Arial</FontName>
                        <FontSize>12</FontSize>
                        <IsBold>False</IsBold>
                        <IsItalic>False</IsItalic>
                        <IsUnderline>False</IsUnderline>
                        <FontBrush>
                            <SolidColorBrush>
                                <Color A="1" R="0" G="0" B="0"> </Color>
                            </SolidColorBrush>
                        </FontBrush>
                    </FontInfo>
                    <ObjectLayout>
                        <DYMOPoint>
                            <X>0.23</X>
                            <Y>0.3498435</Y>
                        </DYMOPoint>
                        <Size>
                            <Width>3.196882</Width>
                            <Height>0.5037009</Height>
                        </Size>
                    </ObjectLayout>
                </BarcodeObject>
            </LabelObjects>
        </DynamicLayoutManager>
    </DYMOLabel>
    <LabelApplication>Blank</LabelApplication>
    <DataTable>
        <Columns> </Columns>
        <Rows> </Rows>
    </DataTable>
</DesktopLabel>`;
